<template>
    <vx-card title="New KnowledgeBase block">
        <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
                <span> Data Type</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
                <v-select  v-validate="'required'" data-vv-validate-on="blur" :options="dataTypes" label="name" v-model="selectedDataType">

                </v-select>
            </div>
        </div>
        <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
                <span> Title</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
                <vs-input  v-validate="'required'" data-vv-validate-on="blur" class="w-full" v-model="title" />
            </div>
        </div>


        <div v-if="selectedDataType && selectedDataType.id==1" class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
                <span>Icon Name</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
                <vs-input  v-validate="'required'" data-vv-validate-on="blur" min="0" class="w-full" type="text" v-model="iconName" />
            </div>
        </div>


        <div v-if="selectedDataType && selectedDataType.id==2" class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
                <span>Image</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
                <vs-upload  v-validate="'required'" data-vv-validate-on="blur" ref="fileInput" :showUploadButton="false" @on-add="successUpload" v-model="files" multiple="false" limit="1" />
            </div>
        </div>


        <div  class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
                <span>URL</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
                <vs-input  v-validate="'required'" data-vv-validate-on="blur" min="0" class="w-full" type="text" v-model="url" />
            </div>
        </div>
    


        <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
                <span>Description</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
                <vs-textarea  v-validate="'required'" data-vv-validate-on="blur" class="w-full" v-model="description" />
            </div>
        </div>

        <div class="vx-row">
            <div class="vx-col sm:w-2/3 w-full ml-auto">
                <vs-button :disabled="!validateForm" @click="createPost" class="mr-3 mb-2">Submit</vs-button>
                
            </div>
        </div>
    </vx-card>
</template>

<script>
    import vSelect from 'vue-select'

    export default {
        components: {
            'v-select': vSelect
        },

        computed: {
    validateForm () {
      return !this.errors.any() && this.selectedDataType !== '' && this.title !== '' && this.url !== '' && this.description !== ''
    }
  },
        
        data() {
            return {
                dataTypes:[
                    {
                        id: 1,
                        name: 'Downloads'
                    },
                    {
                        id: 2,
                        name: 'knowledgebase'
                    }
                ],
                selectedDataType:'',
                title:'',
                iconName:'',
                description:'',
                url:'',
                files:''
            }
        },
        methods: {
            successUpload(){
            },
            
            createPost(){
                // this.$vs.loading()
                const payload = new FormData()

                payload.append("title" , this.title)
                payload.append("Description", this.description)
                payload.append("url" , this.url)
                this.selectedDataType && this.selectedDataType.id==2 ?  payload.append("files", this.$refs['fileInput'].filesx[0])  : payload.append('iconName', this.iconName)
                payload.append("dataType",  this.selectedDataType.id)
                payload.append("iconName" , this.iconName)

               
                
                this.$store.dispatch('post/createPost',payload)
                .then(response => {
                     this.$vs.loading.close()
                        this.$vs.notify({
                            title: 'Successfull',
                            text: response.data.message,
                            iconPack: 'feather',
                            icon: 'icon-check-circle',
                            color: 'success'
                        })
                        setTimeout(()=> this.$router.push(`${this.selectedDataType.id == 1 ? '/downloads' : '/knowledgeBase'}`), 500)
                })
                .catch(error =>{
                    this.$vs.loading.close()
                        this.$vs.notify({
                            title: 'Error',
                            text: error.message,
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'danger'
                        })
                })
            },

          
        }
    }
</script>

<style>

</style>